import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";

const Features = ({data}) => {
  return (
    <div className="section-bg features">
      <Container className="" >
      <SectionHeader mainText1={data.service_name}  />
      <SectionSubHeader headerText={data.title} />
        <Row className="cultures">
        {data.list?.map((listItem) => (
            <Col className="">
               <img src={listItem.icon} alt={listItem.title} />
               <h3>{listItem.title}</h3>
               <p>{listItem.content}</p>
            </Col>
        ))}
          </Row>
      </Container>
       
    </div>
  );
};

export default Features;
